<div class="d-flex flex-column">
  <div class="data-name-itinerary font-poppins">
    <h4 class="w-100" style="color: #000000">FILE N° {{ itinerary?.id }}</h4>
  </div>
  <div
    class="d-flex justify-content-between align-items-center"
    style="border: 1px solid #dfdfdf; border-radius: 6px; padding-top: 0.7em; padding-bottom: 0.7em"
  >
    <div class="d-flex gap-1 align-items-center" style="border-right: 1px solid #dfdfdf; width: 75%">
      <img class="ml-3" width="20px" height="22px" src="../../../../assets/icons/itinerary/placeholder_15914520.svg" alt="" />
      <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px">
        {{ destinySecuency }}
      </p>
    </div>
    <div class="d-flex gap-1 align-items-center" style="border-right: 1px solid #dfdfdf; width: 100%">
      <img class="ml-3" width="25px" src="../../../../assets/icons/itinerary/calendar_13937514.svg" alt="" />
      <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px">
        In: {{ userService.itineraryArrivalDateFull | date: "dd MM yyyy" }} {{ timeArrive }} - Out:
        {{ userService.itineraryDepartureDateFull | date: "dd MM yyyy" }} {{ timeDropoff }}
        &nbsp;
        <span *ngIf="existHotel()" style="font-weight: 700; border-left: 1px solid #000000; padding-left: 0.8em">
          {{ qtyDays }} Días {{ qtyNights }} {{ qtyNights > 1 ? "Noches" : "Noche" }}</span
        >
      </p>
    </div>
    <div class="d-flex gap-1 align-items-center" style="width: 50%">
      <img class="ml-3" width="20px" src="../../../../assets/icons/itinerary/persona.svg" alt="" />
      <p class="mb-0 ml-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px">
        {{ adults }} {{ adults > 1 ? "adultos" : "adulto" }} - {{ children }} {{ children === 1 ? "niño" : "niños" }}
      </p>
    </div>
  </div>
</div>

<!-- Flight Information / Modal  -->
<ng-container *ngIf="itinerary">
  <div
    style="border: 1px solid #dfdfdf; border-radius: 6px; margin-top: 10px;"
  >
    <usb-flight-modal
      class="align-items-center d-flex flex-row w-100"
      [invoke]="1"
      [_actualItinerary]="itinerary"
      [payloadSearch]="payloadSearchTransportFly"
      [formTransports]="formTransportsFly"
      [getClientsSettingAppBooking]="getClientsSettingAppBooking"
      [component]="'results'"
    >
    </usb-flight-modal>
  </div>
</ng-container>
